import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManagementComponent } from './user-management/user-management.component';
import { CustomerOverviewComponent } from './customer-overview/customer-overview.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PhoneMaskModule } from '../custom-user-registration/account-registration/phone-mask.module';

@NgModule({
  declarations: [UserManagementComponent, CustomerOverviewComponent],
  imports: [
    CommonModule,
    I18nModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    BsDatepickerModule.forRoot(),
    PhoneMaskModule,
    ConfigModule.withConfig({
      cmsComponents: {
        UserManagementListComponent: {
          component: UserManagementComponent,
        },
        CustomerDetailsComponent: {
          component: CustomerOverviewComponent,
        }
      },
    } as CmsConfig),
  ],
  providers: [
    provideOutlet({
    id: 'UserRecordSearchSlot',
    position: OutletPosition.REPLACE,
    component: UserManagementComponent,
  }),
  provideOutlet({
    id: 'UserDetailPageSlot',
    position: OutletPosition.REPLACE,
    component: CustomerOverviewComponent,
  }),
  ],
})
export class UserAccessManagementModule { }
